export var tanhDocs = {
  name: 'tanh',
  category: 'Trigonometry',
  syntax: ['tanh(x)'],
  description: 'Compute the hyperbolic tangent of x in radians.',
  examples: ['tanh(0.5)', 'sinh(0.5) / cosh(0.5)'],
  seealso: ['sinh', 'cosh']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/expression/embeddedDocs/function/trigonometry/tanh.js
// module id = 1731
// module chunks = 2